import { transformMaterialList } from "./utils";

export const compileOptionsForChapters = (listItems) => {
  if (!listItems?.length) return [];

  return listItems
    .flatMap((block) => {
      // New API structure: block.chapters[]
      if (block.chapters?.length) {
        return block.chapters.map((chapter) => {
          const versions = [
            ...new Set((chapter.attachments || []).map((a) => a.version)),
          ];
          const maxVersion = versions.length ? Math.max(...versions) : 0;
          return {
            id: chapter.id,
            blockId: block.id,
            value: `Bloco ${block.number} - Capítulo ${chapter.number}`,
            block: block.number,
            chaption: chapter.number,
            versions,
            version: maxVersion,
            numberChaptersBlock: block.chapters.length,
            rescheduledDelivery: block.rescheduledDelivery ?? null,
            rescheduledRelease: block.rescheduledRelease ?? null,
            scheduleDelivery: block.planning?.delivery ?? null,
            scheduleRelease: block.planning?.release ?? null,
          };
        });
      }
      // Old API structure: block.attachments[]
      if (block.attachments?.length) {
        return block.attachments.map((item) => ({
          id: item?.attachment?.id,
          blockId: block?.id,
          value: `Bloco ${block?.blockNumber} - Capítulo ${item?.attachment?.chapterNumber}`,
          block: block?.blockNumber,
          chaption: item?.attachment?.chapterNumber,
          version: item?.attachment?.version,
          numberChaptersBlock: block?.numberChaptersBlock,
          rescheduledDelivery: block?.rescheduledDelivery,
          rescheduledRelease: block?.rescheduledRelease,
          scheduleDelivery: block?.scheduleDelivery,
          scheduleRelease: block?.scheduleRelease,
        }));
      }
      return [];
    })
    .filter(Boolean)
    .sort((a, b) => a.block - b.block || a.chaption - b.chaption);
};

export const compileMaterialsOptions = (listItems) => {
  const filteredList = transformMaterialList(listItems.episodes);

  if (!filteredList.length) return [];

  const validAttachmentTypes = [1209, 1210, 18738];
  const filteredEpisodes = filteredList.filter((episode) =>
    validAttachmentTypes.includes(episode?.attachmentType?.id)
  );

  const episodesData = filteredEpisodes.map((episode) => {
    const attachmentTypeId = episode?.attachmentType?.id;
    const episodeNumber = episode?.episodeNumber;
    const version = episode?.version;

    const versions =
      episode?.attachments?.map((attachment) => {
        return {
          id: attachment.attachment.id,
          fileName: attachment.attachment.fileName,
          version: attachment.attachment.version,
          receivedAt: attachment.attachment.receivedAt,
        };
      }) || [];

    return { attachmentTypeId, episodeNumber, versions, version };
  });

  const groupedData = episodesData.reduce(
    (acc, { attachmentTypeId, episodeNumber, versions, version }) => {
      if (!acc[attachmentTypeId]) {
        acc[attachmentTypeId] = [];
      }
      acc[attachmentTypeId].push({ episodeNumber, versions, version });
      return acc;
    },
    {}
  );

  return groupedData;
};
